module.exports = __webpack_public_path__ + "img/wenzi1.d882e604.png";